export default __webpack_public_path__ + "static/media/nest-icon.da95306b.svg";